import { render } from "./InfoTerms.vue?vue&type=template&id=0a9ce426&scoped=true"
import script from "./InfoTerms.vue?vue&type=script&lang=js"
export * from "./InfoTerms.vue?vue&type=script&lang=js"

import "./InfoTerms.vue?vue&type=style&index=0&id=0a9ce426&lang=scss&scoped=true"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bylex_platform/account/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9ce426"]])

export default __exports__